import { Component, Injector } from '@angular/core';
import { ProductsListFiltersComponent } from '../products-list-filters.component';

@Component({
  selector: 'app-product-list-fitlers-mobile',
  templateUrl: './product-list-fitlers-mobile.component.html',
  styleUrl: './product-list-fitlers-mobile.component.css'
})
export class ProductListFitlersMobileComponent extends ProductsListFiltersComponent {

  constructor(
    private inj: Injector,
  ) {
    super(inj);
  }
  
}
